(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/draws-services.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/draws-services.js');
"use strict";


const _svs$core = svs.core,
  jupiter = _svs$core.jupiter,
  log = _svs$core.log;
const products = svs.utils.products;
const _svs$components$lbUti = svs.components.lbUtils.apiProxy,
  ApiProxy = _svs$components$lbUti.ApiProxy,
  http = _svs$components$lbUti.http,
  featureToggle = _svs$components$lbUti.featureToggle;
const logger = log.getLogger('draws-redux:fetchDrawsPromise');
const FetchState = svs.components.sport.drawsRedux.FetchState;
const STATE_FULFILLED = FetchState.Fulfilled.toLowerCase();
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants.cloudApiFeatureToggles;
const fetchOpenedDrawsPromise = async (drawAPIPath, req) => {
  const customHandler = http.get("/draw/1/:product/draws", _ref => {
    let data = _ref.data;
    return data;
  }, {
    config: {
      shouldUseCloud: async () => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[drawAPIPath.toUpperCase()], {
          req
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws'
    }
  });
  const apiProxy = new ApiProxy([customHandler]);
  const response = await apiProxy.fetch("/draw/1/".concat(drawAPIPath, "/draws"), {
    method: 'GET',
    req
  });
  return response.draws;
};
const fetchDrawsPromise = async function (productId, drawNumber) {
  let shouldFetchJackpot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const customHandler = http.get('/draw/1/:product/draws/:drawNumber', _ref2 => {
    let data = _ref2.data;
    return data;
  }, {
    config: {
      shouldUseCloud: async options => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[options.productName.toUpperCase()], {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
    }
  });
  const drawUrls = [];
  const jackpotUrls = [];
  drawNumber.forEach(draw => {
    const productName = products.getSpecificDrawName(productId);
    drawUrls.push({
      url: "/draw/1/".concat(productName, "/draws/").concat(draw),
      productName
    });
    shouldFetchJackpot && jackpotUrls.push(encodeURIComponent("/draw/1/jackpot/draws?product=".concat(productName, "&drawNumber=").concat(draw)));
  });
  const apiProxy = new ApiProxy([customHandler]);
  const allDrawsPromises = drawUrls.map(drawUrl => apiProxy.fetch(drawUrl.url, {
    method: 'GET',
    productName: drawUrl.productName
  }));
  const drawsResponse = await Promise.allSettled(allDrawsPromises);
  let jackpotResponse;
  if (shouldFetchJackpot && jackpotUrls.length > 0) {
    jackpotResponse = await jupiter.get(jackpotUrls);
  }
  const jackpots = [];
  const draws = {
    draws: [],
    rejectedDraws: []
  };
  drawsResponse.forEach(drawResponse => {
    if (drawResponse.status === STATE_FULFILLED) {
      if (drawResponse.value.error) {
        logger.info("Error fetching draws and/or jackpots, error: ".concat(drawResponse.value.error));
        draws.rejectedDraws.push(drawResponse.value);
      } else {
        draws.draws.push(drawResponse.value);
      }
    }
    if (drawResponse.status === 'rejected') {
      logger.info("Error fetching draws and/or jackpots, error: ".concat(drawResponse.reason));
      draws.rejectedDraws.push({
        error: drawResponse.reason
      });
    }
  });
  jackpotResponse && jackpotResponse.responses.forEach(value => {
    jackpots.push(value);
  });
  return [draws, jackpots];
};
const fetchNetSalePromise = async _ref3 => {
  let productId = _ref3.productId;
  const customHandler = http.get("/draw/1/:product/draws/light", _ref4 => {
    let data = _ref4.data;
    return data;
  }, {
    config: {
      shouldUseCloud: async () => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[products.getDrawName(productId).toUpperCase()], {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben'],
      cloudEndpointTemplate: '/v1/bomben/draws/summary'
    }
  });
  const apiProxy = new ApiProxy([customHandler]);
  const response = await apiProxy.fetch("/draw/1/".concat(products.getDrawName(productId), "/draws/light"), {
    method: 'GET',
    req: undefined
  });
  if (response.error) {
    logger.info("Error fetching netSales, error: ".concat(response.error));
    return [];
  }
  return response.draws || [];
};
setGlobal('svs.components.sport.drawsRedux.services', {
  fetchDrawsPromise,
  fetchOpenedDrawsPromise,
  fetchNetSalePromise
});

 })(window);